// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zg-module--structured[data-v-2d6b1c0c]>div{padding-right:1rem;padding-left:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
